const getCleanQuery = (query: string) =>
  query ? query.trim().toLowerCase() : '';

export default getCleanQuery;
